const getPreviewUrl = (designId: string) => `${LOCAL_ENV.coreEmbeddedEndpoint}/designs/${designId}/preview`;

export default getPreviewUrl;
